import {
    Component,
    OnInit,
    ViewChildren,
    QueryList,
    ElementRef,
    ViewChild,
    AfterViewInit,
} from '@angular/core';
import { AuthService } from '@common/services/auth.service';
import { InMemoryQueryService } from '@common/services/inmemory.query.service';
import { ContentService } from '@common/services/content.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { SpjpCommunityService } from '@spjp/services/community.service';
import { ReplaySubject } from 'rxjs';
import { MenuItem, MenuService } from '@spjp/services/menu.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    standalone: false
})
export class MenuComponent implements OnInit, AfterViewInit {
    @ViewChildren(NgbDropdown) dropdowns!: QueryList<NgbDropdown>;

    items$: ReplaySubject<MenuItem[]>;
    @ViewChild(`headerDiv`)
    headerDiv: ElementRef;

    showMenu = true;
    showMenuLinks = true;
    regex = /\/|\?|\#/;
    navbarCollapsed = true;
    placeholderStyle = { height: '60px' };

    get communityIsValid() {
        return this.communityService.communityIsValid;
    }

    get communityCode() {
        return this.communityService.communityCode;
    }

    get page() {
        return window.location.pathname.split(this.regex)[3];
    }

    get hasWideLogoForMobileUsed$() {
        return this.contentService.valueExists('menu-logo-wide-mobile');
    }

    get hasWideLogoUsed$() {
        return this.contentService.valueExists('menu-logo-wide');
    }

    constructor(
        public communityService: SpjpCommunityService,
        public authService: AuthService,
        public contentService: ContentService,
        private queryService: InMemoryQueryService,
        private menuService: MenuService,
    ) {}

    moreInfoDropdownClick() {
        this.navbarCollapsed = true;
        this.dropdowns.forEach((dropdown) => dropdown.close());
    }

    ngOnInit(): void {
        this.queryService.getObservable$('app-menu').subscribe((e) => {
            if (e.name === 'showMenu' && e.value !== null) {
                this.showMenu = e.value;
            } else if (e.name === 'showMenuLinks' && e.value !== null) {
                this.showMenuLinks = e.value;
            }
        });

        this.items$ = this.menuService.menuItems$;
    }

    ngAfterViewInit() {
        if (
            this.headerDiv &&
            this.headerDiv.nativeElement &&
            this.headerDiv.nativeElement.clientHeight
        ) {
            this.placeholderStyle = {
                height: this.headerDiv.nativeElement.clientHeight + 'px',
            };
        }
    }
}
